'use client';

import { useState } from 'react';
import { PrismicNextLink } from '@prismicio/next';
import { JSXMapSerializer, PrismicRichText } from '@prismicio/react';
import { Content } from '@prismicio/client';
import { ArrowRight } from '@/assets';
import { OptimizedPrismicImage } from '@/components';
import { Simplify } from '../../../../../../prismicio-types';
import { consistentAnimationDuration } from '@/utils';
import styles from './loanUsesCards.module.scss';
import AnimationContainer from '@/components/Animation/AnimationContainer';

interface Props {
  index: number;
  isVisible: boolean;
  item: Simplify<Content.LoanUsesSliceDefaultPrimaryCardsItem>;
  animation: object;
}

const components: JSXMapSerializer = {
  heading4: ({ children }) => <h4 className={styles.heading}>{children}</h4>,
};

const Card = ({ index, isVisible, item, animation }: Props) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <li
      className={`${styles.item} ${isVisible ? styles.isVisible : ''}`}
      style={consistentAnimationDuration(1.1, index)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <PrismicNextLink
        field={item.link}
        className={`${styles.card} ${index === 1 ? styles.defaultCard : ''}`}
      >
        {index === 1 ? (
          <>
            <PrismicRichText field={item.heading} components={components} />
            <ArrowRight />
            <OptimizedPrismicImage
              field={item.image}
              className={styles.image}
            />
          </>
        ) : (
          <AnimationContainer
            isActive
            loop={false}
            play={isHovered}
            animation={animation}
            className={`${styles.animation} ${index === 0 ? styles.scaledAnimation : ''}`}
          />
        )}
      </PrismicNextLink>
    </li>
  );
};

export default Card;
